import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss']
})
export class AlertComponent {

    title: string;
    text: string;
    textBtnClose = 'system.got-it';
    @Output() closeEmitter: EventEmitter<any> = new EventEmitter();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialogRef<AlertComponent>,
    ) {
        if (data) {
            this.title = data.title;
            this.text = data.text;
            this.textBtnClose = data.textBtnClose ? data.textBtnClose : 'system.got-it';
        }
    }

    close() {
        this.closeEmitter.emit();
        this.dialog.close();
    }

}
